import { PageLayout } from "@/components/layouts/PageLayout";
import { useAppContext } from "@/modules/app/providers/AppContextProvider";
import { useIntl } from "react-intl";
import { Navigate } from "react-router-dom";
import YearInReview from "./containers/YearInReview";

export default function YearInReviewPage() {
  const { user } = useAppContext();
  const intl = useIntl();

  if (!user) {
    return <Navigate to="/home" />;
  }

  return (
    <PageLayout title={intl.formatMessage({ defaultMessage: "Итоги года" })}>
      <YearInReview user={user} />
    </PageLayout>
  );
}

